import { useState, useCallback } from 'react'
import jwt from 'jwt-decode'
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

export function useForceUpdate() {
  const [, setTick] = useState(0);
  const update = useCallback(() => {
    setTick(tick => tick + 1);
  }, [])
  return update;
}

var timeDiff = function (date1, date2, secondsVisible) {
  var a = new Date(date1).getTime(),
    b = new Date(date2).getTime(),
    diff = {};

  diff.milliseconds = a > b ? a % b : b % a;
  diff.seconds = diff.milliseconds / 1000;
  diff.minutes = diff.seconds / 60;
  diff.hours = diff.minutes / 60;
  diff.days = diff.hours / 24;
  diff.weeks = diff.days / 7;

  let response = '';

  if (Math.floor(diff.days) > 0)
    response += `${Math.floor(diff.days)}d `;

  if (Math.floor(diff.hours) > 0)
    response += `${Math.floor(diff.hours - (Math.floor(diff.days) * 24))}h `;

  if (Math.floor(diff.minutes) > 0)
    response += `${Math.floor(diff.minutes - (Math.floor(diff.hours) * 60))}min `;

  if (secondsVisible && Math.floor(diff.seconds) > 0)
    response += `${Math.floor(diff.seconds - (Math.floor(diff.minutes) * 60))}s `;

  return response || '0s';
}

export const calcTempoConfirmacao = (value) => {
  try {
    const time = Math.max(0, value);
    const isOld = time > 60 * 60000;
    const date = dayjs
      .duration(time)
      .format(' M [m], H [h], m [min]')
      .split(',')
      .filter(text => !text.match(/ (0) /));
    const dateTime = date.toString().replace(/,/g, '');
    return { dateTime, isOld }
  } catch (e) {
    console.log('calcTempoConfirmacao', e);
    return {
      dateTime: '',
      isOld: false
    }
  }
};

export function getTimeDiff(t) {
  const a = new Date(t);
  const b = new Date();
  return timeDiff(a, b, false);
}

export function getTimeStr(t) {
  const a = new Date(t);
  return a.toLocaleDateString();
}

export function getTimeWithHourStr(t) {
  const date = new Date(t);
  const time = date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'UTC'
  });

  return `${date.toLocaleDateString()} ${time}`;
}

export function getTimeStrUtc(t) {
  const date = new Date(t);
  return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
}

export function getTimeWithHourStrUtc(t) {
  const date = new Date(t);
  const time = date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'UTC'
  });

  return `${getTimeStrUtc(t)} ${time}`;
}

export function getTimeBetweenDates(date, dateNext, secondsVisible) {
  const a = new Date(date);
  const b = new Date(dateNext || new Date());

  return timeDiff(a, b, secondsVisible);
}

export function getCostString(val) {
  const valStr = (typeof val === 'number') ? val.toLocaleString(undefined, { minimumFractionDigits: 2 }) : val;
  return `R$ ${valStr}`;
}

export function getAppUser(token) {
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const user = jwt(token ? token : userInfo.token);
    return { ...user, loja: userInfo.loja };
  } catch {
    return {};
  }
}

export function getLabelDeliveryType(tipoEntrega) {
  switch (tipoEntrega) {
    case "RETIRADA":
      return "Retirada: Cliente retira o pedido";
    case "INTERNA":
      return "Interna: Associado como Entregador";
    case "EXTERNA":
      return "Externa: Motoboy";
    default:
      return 'Não definida';
  }
}

export const getLabelStatus = {
  'new-orders': 'Novo Pedido',
  'estimated': 'Previsto',
  'new-orders-criado': 'Criado',
  'new-orders-incluido': 'Chegada',
  'new-orders-visualizado': 'Visualizado',
  'edited': 'Editado',
  'picking': 'Em Separação',
  'in-edition': 'Em Edição',
  'ready-to-go': 'Pronto para Retirada',
  'shipping': 'Saiu para Entrega',
  'returning-to-storage': 'Retornar Para Estoque',
  'return-to-stock': 'Devolver para Estoque',
  'paid': 'Pagamento Confirmado',
  'invoice': 'Nota Fiscal Emitida',
  'concluded': 'Entregue',
  'canceled': 'Cancelado',
  'canceled-from-store': 'Cancelado Pela Loja',
  'returned': 'Devolvido',
  'recused': 'Recusado',
  'withdrawn': 'Retirado',
  'delivered': 'Entregue',
  'confirmed-change': 'Alteração Confirmada',
  'without-pendency': 'Sem Pendência',
}
